module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "clientes"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "padding": "40px",
      "margin-top": "100px"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('hr'), _vm._v(_vm._s(_vm.state.title))])]), _vm._v(" "), _c('h1', {
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(_vm._s(_vm.state.subTitle))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientes-container"
  }, [_c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_alen_gris.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_cemenquin_gris.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_fevisa_gris.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_jumex_gris.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientes-container"
  }, [_c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logos_azteca_gris.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_maseca_gris.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_pazher_gris.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_psf_gris.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientes-container"
  }, [_c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_sunpower_gris.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_vitro_gris.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_zahori_gris.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df3a6bd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/ClientesPage.vue
// module id = 156
// module chunks = 0